var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout d-flex flex-column"},[_c('div',{staticClass:"container-fluid col h-100",attrs:{"id":"content"}},[_c('div',{staticClass:"row h-100"},[_c('div',{staticClass:"col mw-25"},[_c('vue-perfect-scrollbar',[_c('div',{staticClass:"p-4 min-vh-80"},[_c('o-child')],1)])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }